<script lang="ts" setup>
import { useForwardPropsEmits } from "reka-ui"
import type { DrawerRootEmits, DrawerRootProps } from "vaul-vue"
import { DrawerRoot } from "vaul-vue"

const props = withDefaults(defineProps<DrawerRootProps>(), {
    shouldScaleBackground: true
})

const emits = defineEmits<DrawerRootEmits>()

const forwarded = useForwardPropsEmits(props, emits) as DrawerRootProps
</script>

<template>
    <DrawerRoot v-bind="forwarded">
        <slot />
    </DrawerRoot>
</template>
